export default "__VITE_ASSET__Cy9X_RZR__"